export default {"src":"/_next/static/media/homepage_characters.a1cf6cc4.svg","height":2315,"width":3889};